import { OpenInNew } from "@mui/icons-material";
import { Link as MuiLink, type LinkProps as MuiLinkProps, styled, type SvgIconProps } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { type Except } from "type-fest";

const StyledLink = styled(MuiLink)<MuiLinkProps>(function () {
  return { alignItems: "center", display: "inline-flex", gap: "0.5ch" };
});

/** Links to a page outside of the application. */
export type ExternalLinkBaseProps = MuiLinkProps & { type: "external"; hideIcon?: boolean; href: string };

export interface ExternalLinkSlotProps {
  slotProps?: { icon?: SvgIconProps; link?: Except<MuiLinkProps<"a">, "href"> };
}
export type ExternalLinkProps = ExternalLinkBaseProps & ExternalLinkSlotProps;

/** Links to a page inside of the application. */
export type InternalLinkBaseProps = Except<MuiLinkProps<typeof RouterLink>, "component"> & { type: "internal" };
export interface InternalLinkSlotProps {
  slotProps?: { link?: MuiLinkProps<typeof RouterLink> };
}
export type InternalLinkProps = InternalLinkBaseProps & InternalLinkSlotProps;

export type LinkBaseProps = ExternalLinkProps | InternalLinkProps;
export interface LinkSlotProps {
  slotProps?: { icon?: SvgIconProps };
}
export type LinkProps = LinkBaseProps & LinkSlotProps;

export function Link(props: LinkProps) {
  const { slotProps, type, children, ...restProps } = props;

  if (type === "external") {
    const { hideIcon, slotProps, ...restProps } = props as ExternalLinkProps;
    return (
      <StyledLink rel="noopener noreferrer" target="_blank" {...restProps} {...slotProps?.link}>
        {children}
        {!hideIcon && <OpenInNew fontSize="inherit" {...slotProps?.icon} />}
      </StyledLink>
    );
  }

  return (
    <StyledLink component={RouterLink} {...restProps} {...slotProps?.link}>
      {children}
    </StyledLink>
  );
}
